import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import Layout from '../app/Layout';
import AccountDetailPage from './accounts/AccountDetailPage';
import AccountsPage from './accounts/AccountsPage';
import JournalPage from './journal/JournalPage';
import PartnerListDetailPage from './partners/PartnerListDetailPage';
import PartnerListsPage from './partners/PartnerListsPage';
import RoleDetailPage from './roles/RoleDetailPage';
import RolesPage from './roles/RolesPage';
import UserDetailPage from './users/UserDetailPage';
import UsersPage from './users/UsersPage';
import OnboardingPage from './users/onboarding/OnboardingPage';

const Pages = () => {
    return (
        <BrowserRouter>
            <Layout>
                <Routes>
                    <Route path="/" element={<Navigate to="/utilisateurs" replace />} />
                    <Route path="/utilisateurs" element={<UsersPage />} />
                    {/* Before the :userId route: "nouveau" is a screen, not an identifier. */}
                    <Route path="/utilisateurs/nouveau" element={<OnboardingPage />} />
                    <Route path="/utilisateurs/:userId" element={<UserDetailPage />} />
                    <Route path="/comptes" element={<AccountsPage />} />
                    <Route path="/comptes/:accountId" element={<AccountDetailPage />} />
                    <Route path="/roles" element={<RolesPage />} />
                    <Route path="/roles/:roleId" element={<RoleDetailPage />} />
                    <Route path="/listes-de-partenaires" element={<PartnerListsPage />} />
                    <Route path="/listes-de-partenaires/:partnerListId" element={<PartnerListDetailPage />} />
                    <Route path="/journal" element={<JournalPage />} />
                    <Route path="*" element={<Navigate to="/utilisateurs" replace />} />
                </Routes>
            </Layout>
        </BrowserRouter>
    );
};

export default Pages;
